import { useState } from 'react';
import { money } from './format';

// Окно отметки оплаты транша: ввод фактически полученной суммы (всего по траншу)
// и № платёжки/выписки. Позволяет частичную оплату (факт < плана).
export function PayMarkModal({
  dealNo,
  label,
  amount,
  paidAmount,
  paidRef,
  onClose,
  onSubmit,
}: {
  dealNo: string;
  label: string;
  amount: number; // плановая сумма транша
  paidAmount: number; // уже отмечено полученным
  paidRef: string | null;
  onClose: () => void;
  onSubmit: (amount: number, ref: string) => Promise<void>;
}) {
  const [amt, setAmt] = useState<string>(String(paidAmount > 0 ? paidAmount : amount));
  const [ref, setRef] = useState(paidRef ?? '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const val = Math.max(0, Math.min(Math.round(Number(amt) || 0), amount));
  const partial = val > 0 && val < amount;

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">Отметить оплату</div>
            <div className="m-no">
              {dealNo} · {label}
            </div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <div className="glass pad" style={{ margin: '0 0 12px' }}>
            <div className="row" style={{ justifyContent: 'space-between' }}>
              <span className="muted small">План транша</span>
              <span className="mono">{money(amount)}</span>
            </div>
            {paidAmount > 0 && (
              <div className="row" style={{ justifyContent: 'space-between' }}>
                <span className="muted small">Уже получено</span>
                <span className="mono">{money(paidAmount)}</span>
              </div>
            )}
          </div>

          <label className="fld">
            <span className="muted small">Получено по траншу (всего), ₸</span>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                type="number"
                className="grow"
                value={amt}
                disabled={busy}
                onChange={(e) => setAmt(e.target.value)}
                autoFocus
              />
              <button
                className="btn ghost sm"
                disabled={busy}
                type="button"
                onClick={() => setAmt(String(amount))}
              >
                Полностью
              </button>
            </div>
          </label>

          <label className="fld" style={{ marginTop: 10 }}>
            <span className="muted small">№ платёжки / выписки (необязательно)</span>
            <input
              className="grow"
              value={ref}
              disabled={busy}
              onChange={(e) => setRef(e.target.value)}
              placeholder="напр. ПП №1421 от 06.08"
            />
          </label>

          {partial && (
            <p className="muted small" style={{ marginTop: 10 }}>
              Частичная оплата: {money(val)} из {money(amount)}. Транш останется «не оплачён
              полностью» — правило входа в производство сработает только при полной сумме.
            </p>
          )}

          <div
            style={{
              display: 'flex',
              gap: 8,
              justifyContent: 'flex-end',
              flexWrap: 'wrap',
              marginTop: 14,
            }}
          >
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button
              className="btn sm"
              disabled={busy || val <= 0}
              onClick={async () => {
                setBusy(true);
                setMsg(null);
                try {
                  await onSubmit(val, ref.trim());
                } catch (e) {
                  // Ошибка сохранения показывается, окно остаётся открытым (не зависает молча).
                  setMsg(e instanceof Error ? e.message : 'Не удалось сохранить оплату.');
                } finally {
                  setBusy(false);
                }
              }}
            >
              {busy ? 'Сохраняем…' : `Отметить · ${money(val)}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
